import { TableHeadersType } from "./tableHeadersType";

export const ALL_USER_LEAVE_LIST: TableHeadersType[] = [
  {
    label: "START DATE",
    value: "start_date",
  },
  {
    label: "END DATE",
    value: "end_date",
  },
  {
    label: "NO OF DAYS",
    value: "total_days",
  },
  {
    label: "APPROVER",
    value: "approved_by",
  },
  {
    label: "LEAVE TYPE",
    value: "leave_type",
  },
  {
    label: "REASON",
    value: "reason",
  },
  // {
  //   label: "REMAINING LEAVE",
  //   value: "approved_leave",
  // },
];
